{
  "dependencies": {
    "@angular/aria": "^22.2.4",
    "@angular/cdk": "^22.2.4",
    "@angular/common": "^22.2.3",
    "@angular/compiler": "^22.2.3",
    "@angular/core": "^22.2.3",
    "@angular/forms": "^22.2.3",
    "@angular/material": "^22.2.4",
    "@angular/platform-browser": "^22.2.3",
    "@angular/platform-browser-dynamic": "^22.2.3",
    "@angular/router": "^22.2.3",
    "@angular/service-worker": "^22.2.3",
    "@auth0/auth0-angular": "^2.2.3",
    "@flywheel-io/extension": "^0.14.9",
    "@flywheel-io/fw-file-rs": "^0.9.1",
    "@flywheel-io/vision": "^22.1.2",
    "@monaco-editor/loader": "^1.5.0",
    "@sentry/angular": "^11.9.0",
    "@tanstack/angular-query-experimental": "5.105.0",
    "@types/lodash-es": "^4.17.12",
    "@zip.js/zip.js": "^2.24.0",
    "ajv": "^8.17.2",
    "cronstrue": "^2.58.0",
    "date-fns": "^2.28.0",
    "date-fns-tz": "^1.3.4",
    "dcmjs": "~0.38.0",
    "echarts": "^6.0.0",
    "js-yaml": "^3.14.0",
    "lodash-es": "^4.17.21",
    "marked": "^14.1.2",
    "monaco-editor": "^0.57.0",
    "ngx-echarts": "^22.0.0",
    "ngx-sse-client": "^21.0.0",
    "node-forge": "^1.4.0",
    "numbro": "^2.3.2",
    "rxjs": "~7.8.0",
    "safe-regex2": "^5.1.2",
    "tslib": "^2.3.0",
    "userpilot": "^1.4.3",
    "yaml": "^2.8.2",
    "zone.js": "^0.16.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "22.6.0",
    "@angular-eslint/eslint-plugin": "22.6.0",
    "@angular-eslint/eslint-plugin-template": "22.6.0",
    "@angular-eslint/schematics": "22.6.0",
    "@angular-eslint/template-parser": "22.6.0",
    "@angular/build": "^22.2.4",
    "@angular/cli": "~22.2.4",
    "@angular/compiler-cli": "^22.2.3",
    "@compodoc/compodoc": "^2.0.0",
    "@eslint/js": "10.0.1",
    "@types/chai": "^5.0.1",
    "@types/mocha": "^10.0.10",
    "@types/node-forge": "^1.3.14",
    "@types/sinon": "^22.0.2",
    "@types/wicg-file-system-access": "^2023.10.7",
    "angular-eslint": "^22.6.0",
    "chai": "^4.2.0",
    "eslint": "10.13.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-simple-import-sort": "~14.0.0",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~4.3.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-mocha": "^2.0.1",
    "karma-mocha-reporter": "^2.2.5",
    "karma-sourcemap-loader": "^0.4.0",
    "karma-spec-reporter": "^0.0.37",
    "mocha": "^12.0.0",
    "patch-package": "^8.0.0",
    "prettier": "3.9.10",
    "puppeteer": "^25.16.0",
    "sinon": "^8.1.1",
    "stylelint": "^17.0.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "8.72.0"
  },
  "overrides": {
    "zone.js": "^0.16.0",
    "diff": "^9.0.0",
    "dompurify": "^3.3.3",
    "qs": "^6.14.1",
    "serialize-javascript": "^7.0.4",
    "tar": "^7.5.6",
    "karma": {
      "minimatch": "^8.0.7"
    },
    "picomatch": "^4.0.4",
    "adm-zip": "^0.6.1",
    "vite": "~8.3.5"
  },
  "engines": {
    "node": ">=24.15.0"
  },
  "name": "@flywheel-io/frontend",
  "private": true,
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "NODE_ENV=production NODE_OPTIONS=--max_old_space_size=8192 ng build",
    "lint": "ng lint",
    "lint:ci": "ng lint --quiet",
    "format": "prettier --write .",
    "organize-imports": "eslint \"app/**/*.ts\" --config eslint-imports-only.config.js --fix && prettier --write \"app/**/*.ts\"",
    "postinstall": "patch-package && (git config blame.ignoreRevsFile .git-blame-ignore-revs || exit 0)",
    "remote": "PROXY_HOST=${PROXY_HOST:-core-test.staging.flywheel.io} npm start",
    "remote:central": "PROXY_HOST=zymg55.dev.ten.flywheel.io npm start",
    "check-test-ids": "node scripts/check-test-ids.js",
    "check-test-ids:all": "node scripts/check-test-ids.js --all",
    "check-test-ids:report": "node scripts/check-test-ids.js --all --report",
    "check-format": "prettier --check .",
    "stylelint": "npx stylelint '**/*.scss'",
    "stylelint:fix": "npx stylelint '**/*.scss' --fix",
    "compodoc": "npx compodoc -p tsconfig.json",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:ci": "NODE_OPTIONS=--max_old_space_size=8192 ng test --no-watch --karma-config karma.ci.conf.js",
    "test:debug": "ng test --karma-config karma.debug.conf.js",
    "test:watch": "ng test --karma-config karma.watch.conf.js",
    "test:puppeteer": "ng test --karma-config karma.puppeteer.conf.js"
  },
  "version": "23.1.0",
  "allowScripts": {
    "@compodoc/compodoc@1.2.1": true,
    "@parcel/watcher@2.5.6": true,
    "browser-tabs-lock@1.3.0": true,
    "core-js-pure@3.49.0": true,
    "esbuild@0.27.3": true,
    "lmdb@3.5.1": true,
    "puppeteer@24.42.0": true,
    "msgpackr-extract@3.0.4": true,
    "esbuild@0.28.1": true
  }
}
